/**
 * Route: /splits/:id — Story 2.3-UI (Split-Editor)
 *
 * Editor-Formular fuer eine bestehende Provisions-Regel
 * (PATCH /api/v2/host_split_rules/:id) mit Live-Vorschau.
 */
import { createFileRoute } from '@tanstack/react-router'
import { SplitRuleEditor } from '../features/splits/SplitRuleEditor'

export const Route = createFileRoute('/_auth/splits/$id')({
  component: SplitDetailRoute,
})

function SplitDetailRoute() {
  const { id } = Route.useParams()
  return <SplitRuleEditor mode="edit" id={Number(id)} key={id} />
}
